import ScrollToTop from "./components/ScrollToTop";
import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { ServicesPage } from "./pages/ServicesPage";
import { ValuesPage } from "./pages/ValuesPage";
import { WorkingMethodPage } from "./pages/WorkingMethodPage";
import { ContactPage } from "./pages/ContactPage";
import { ImpressumPage } from "./pages/ImpressumPage";
import { DatenschutzPage } from "./pages/DatenschutzPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />   {/* <<< SCROLL FIX – HIER MUSS ES HIN */}
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/leistungen" element={<ServicesPage />} />
            <Route path="/werte" element={<ValuesPage />} />
            <Route path="/arbeitsweise" element={<WorkingMethodPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;

